$( function() {
	// $('.plan__item').tooltipster({
	// 	theme: ['tooltipster-shadow', 'tooltipster-shadow-customized'],
	// 	delay: 200,
	// 	maxWidth: 220,
	// 	distance: -5
	// });
} );

